<template>
  <content-box class="jam-filter-wrap" :style="{'width': this.type === 'basketList' ? '407px':'535px'}" >
    <div  @click.stop.prevent>
      <div class="date">
        <div class="desc">
          <span>{{$t('common.filterPeriod')}}</span>
        </div>
        <div class="date_picker_input--wrap">
          <div class="datepicker--wrap data__start-date">
            <span class="date_picker_input">
              <i class="icon icon--calendar-input"></i>
              <input type="text"
                     :value="startDateStr"
                     :placeholder="'YYYY-MM-DD'"
                     @click.stop.prevent="toggleDatePicker('start')"
                     :style="{'width': this.type === 'basketList' ? '140px': 'none'}"
                     readonly>
            </span>
          </div>
          <span class="date_seperator"> ~ </span>
          <div class="datepicker--wrap data__end-date">
            <span class="date_picker_input">
              <i class="icon icon--calendar-input"></i>
              <input type="text" :value="endDateStr" :placeholder="'YYYY-MM-DD'" @click.stop.prevent="toggleDatePicker('end')" :style="{'width': this.type === 'basketList' ? '140px': 'none'}" readonly >
            </span>
          </div>

          <span class="reset">
            <i class="icon icon--reset-large" @click="initDate">
              <i class="icon icon--filter-hover"></i>
            </i>
          </span>
        </div>
      </div>

      <div class="filter">
        <div class="filter-chk-list">
          <div class="type type-service" v-if="type==='jamList'">
            <div class="title">
              <span>{{ $t('plan.jam.service') }}</span>
            </div>
            <div class="filter-list">
              <ul>
                <li>
                  <ui-checkbox :value="filterServiceAll.value" @input="onCheckFilterService('All')">
                    {{filterServiceAll.text}}
                  </ui-checkbox>
                </li>
                <li>
                  <ui-checkbox :value="filterServiceJourney.value" @input="onCheckFilterService('Journey')">
                    {{filterServiceJourney.text}}
                  </ui-checkbox>
                </li>
                <li>
                  <ui-checkbox :value="filterServiceHeatmap.value" @input="onCheckFilterService('Heatmap')">
                    {{filterServiceHeatmap.text}}
                  </ui-checkbox>
                </li>
                <li>
                  <ui-checkbox :value="filterServiceETC.value" @input="onCheckFilterService('ETC')">
                    {{filterServiceETC.text}}
                  </ui-checkbox>
                </li>
              </ul>
            </div>
          </div>
          <div class="type type-jam">
            <div class="title">
              <span>{{ $t('plan.jam.chargedJam') }}</span>
            </div>
            <div class="filter-list">
              <ul>
                <li>
                  <ui-checkbox :value="filterJamAll.value" @input="onCheckFilterJam('All')">
                    {{filterJamAll.text}}
                  </ui-checkbox>
                </li>
                <li>
                  <ui-checkbox :value="filterJamAdd.value" @input="onCheckFilterJam('Add')">
                    {{filterJamAdd.text}}
                  </ui-checkbox>
                </li>
                <li>
                  <ui-checkbox :value="filterJamSubtract.value" @input="onCheckFilterJam('Subtract')">
                    {{filterJamSubtract.text}}
                  </ui-checkbox>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="type type-detail">
          <div class="title">
            <span>{{ $t('plan.jam.detail') }}</span>
          </div>
          <div class="filter-list">
            <ul>
              <template v-for="item in filterJamDetailList">
                <li :key="item.key">
                  <ui-checkbox :value="item.value" @input="onCheckFilterJamDetail(item.key)">
                    {{ $t('plan.jam.jamState.'+item.key) }}
                  </ui-checkbox>
                </li>
              </template>
            </ul>
          </div>
        </div>
        <div class="type type-payment" v-if="type==='jamList'">
          <div class="title">
            <span>{{ $t('common.paymentMethod') }}</span>
          </div>
          <div class="filter-list">
            <ul>
              <template v-for="item in filterPaymentDetailList">
                <li :key="item.key">
                  <ui-checkbox :value="item.value" @input="onCheckFilterPaymentDetail(item.key)">
                    {{ $t('plan.jam.jamState.'+item.key) }}
                  </ui-checkbox>
                </li>
              </template>
            </ul>
          </div>
        </div>
      </div>

      <div class="buttons">
        <ui-button @click="onCancel">
          {{$t('common.cancel')}}
        </ui-button>
        <ui-button :class="'primary'" @click="onSubmit" :disabled="!isChangeFilter">
          {{$t('common.confirm')}}
        </ui-button>
      </div>

      <div class="data__start-date" v-if="showStartDatePicker">
        <date-picker v-if="showStartDatePicker"
                     :style="{'left': '28%', 'top':'5px'}"
                     :value="startDate"
                     :isShowTimezone="true"
                     :isShowTimezoneValue="true"
                     :maxDate="maxStartDate"
                     :timezone="timezone"
                     :timezoneName="timezoneName"
                     :isYearMove="true"
                     @input="onCalendarDateChange('startDate', $event)"
                     @onCloseClick="showStartDatePicker = false"/>
      </div>
      <div class="data__end-date" v-if="showEndDatePicker">
        <date-picker v-if="showEndDatePicker"
                     :value="endDate"
                     :style="{'top':'5px'}"
                     :minDate="minEndDate"
                     :maxDate="maxEndDate"
                     :isShowTimezone="true"
                     :isShowTimezoneValue="true"
                     :timezone="timezone"
                     :timezoneName="timezoneName"
                     :isYearMove="true"
                     @input="onCalendarDateChange('endDate', $event)"
                     @onCloseClick="showEndDatePicker = false"/>
      </div>
    </div>
  </content-box>
</template>

<script>
import ContentBox from '@/components/ui/ContentBox'
import DatePicker from '@/components/date-picker/index.vue'
import { mapActions, mapMutations, mapState } from 'vuex'
import { utcToLocalTimezone } from '@/libs/utils'
import { endOfDay, format, parse, startOfDay } from 'date-fns'
import {
  DEFAULT_TIMEZONE,
  DEFAULT_TIMEZONE_NAME,
  JAM_BASKET_LIST_STATE,
  JAM_LIST_STATE,
  JAM_PAYMENT_LIST_STATE
} from '@/libs/constants'
import UiCheckbox from '@/components/ui/UiCheckbox.vue'
import UiButton from '@/components/ui/UiButton.vue'

export default {
  components: {
    UiButton,
    UiCheckbox,
    DatePicker,
    ContentBox
  },
  props: [
    'type',
    'filterList',
    'filterPaymentList',
    'dateRange',
    'serviceType',
    'jamValue'
  ],
  data () {
    return {
      showStartDatePicker: false,
      showEndDatePicker: false,
      filterJamAll: {
        value: true, text: this.$t('common.all'), key: 'all'
      },
      filterJamAdd: {
        value: true, text: this.$t('plan.jam.jamFilter.addJam'), key: 'add'
      },
      filterJamSubtract: {
        value: true, text: this.$t('plan.jam.jamFilter.subtractJam'), key: 'subtract'
      },
      filterServiceAll: {
        value: true, text: this.$t('common.all'), key: 'all'
      },
      filterServiceJourney: {
        value: true, text: 'Journey Map', key: 'ba'
      },
      filterServiceHeatmap: {
        value: true, text: 'UX Heatmap', key: 'beusable'
      },
      filterServiceETC: {
        value: true, text: this.$t('common.etc'), key: 'etc'
      },
      filterJamDetailList: [],
      filterPaymentDetailList: [],
      startDate: null,
      endDate: null,
      isChangeFilter: false,
      startDateStr: null,
      endDateStr: null,
      originJamState: null,
      originServiceState: null
    }
  },
  computed: {
    ...mapState([
      'domain'
    ]),
    timezone () {
      return DEFAULT_TIMEZONE
    },
    timezoneName () {
      return DEFAULT_TIMEZONE_NAME
    },
    minEndDate () {
      if (this.startDate) {
        return parse(this.startDate)
      } else {
        return null
      }
    },
    maxEndDate () {
      return null
    },
    maxStartDate () {
      if (this.endDate) {
        return utcToLocalTimezone(new Date(this.endDate), this.timezoneName)
      } else {
        return null
      }
    }
  },
  methods: {
    ...mapMutations(['setJamListFilter']),
    onCheckChangeFilter () {
      this.isChangeFilter = false
      const originStartDate = JSON.parse(JSON.stringify(this.dateRange.startDate))
      const originEndDate = JSON.parse(JSON.stringify(this.dateRange.endDate))
      const originFilterJamDetailList = JSON.parse(JSON.stringify(this.filterList))
      const originFilterPaymentDetailList = JSON.parse(JSON.stringify(this.filterPaymentList))

      if (originStartDate !== this.startDate) {
        this.isChangeFilter = true
      }
      if (originEndDate !== this.endDate) {
        this.isChangeFilter = true
      }

      originFilterJamDetailList.forEach((item, index) => {
        const originValue = item.value

        const target = this.filterJamDetailList[index]
        if (originValue !== target.value) {
          this.isChangeFilter = true
        }
        if (this.isChangeFilter) {
          return true
        }
      })

      originFilterPaymentDetailList.forEach((item, index) => {
        const originValue = item.value

        const target = this.filterPaymentDetailList[index]
        if (originValue !== target.value) {
          this.isChangeFilter = true
        }
        if (this.isChangeFilter) {
          return true
        }
      })

      const currentJamState = {
        jamAdd: this.filterJamAdd.value,
        jamSubtract: this.filterJamSubtract.value
      }

      if (
        this.originJamState.jamAdd !== currentJamState.jamAdd ||
        this.originJamState.jamSubtract !== currentJamState.jamSubtract
      ) {
        this.isChangeFilter = true
      }

      const currentServiceState = {
        journey: this.filterServiceJourney.value,
        heatmap: this.filterServiceHeatmap.value,
        etc: this.filterServiceETC.value
      }

      const changed =
        this.originServiceState.journey !== currentServiceState.journey ||
        this.originServiceState.heatmap !== currentServiceState.heatmap ||
        this.originServiceState.etc !== currentServiceState.etc

      if (changed) {
        this.isChangeFilter = true
      }
    },
    onCancel () {
      this.$emit('onClose')
    },
    onSubmit () {
      const selectedServiceType = [
        this.filterServiceJourney.value && 'ba',
        this.filterServiceHeatmap.value && 'beusable',
        this.filterServiceETC.value && 'etc'
      ].filter(Boolean)

      const jamValues = {
        add: this.filterJamAdd.value,
        subtract: this.filterJamSubtract.value
      }

      this.setJamListFilter(this.getJamDetailFilter())
      this.$emit('onChangeJamFilter', this.filterJamDetailList, this.filterPaymentDetailList, { startDate: this.startDate, endDate: this.endDate }, selectedServiceType, jamValues)
    },
    getJamDetailFilter () {
      const ETC_KEYS = ['JAM_CHARGE', 'REWARD', 'JAM_EXPIRED']

      const {
        filterServiceETC,
        filterServiceJourney,
        filterServiceHeatmap,
        filterJamAll,
        filterJamAdd,
        filterJamSubtract
      } = this

      const isETC = filterServiceETC.value
      const isJourney = filterServiceJourney.value
      const isHeatmap = filterServiceHeatmap.value

      const isAll = filterJamAll.value
      const isAdd = filterJamAdd.value
      const isSubtract = filterJamSubtract.value
      const jamList = this.type === 'jamList' ? JAM_LIST_STATE : JAM_BASKET_LIST_STATE

      // 1. 서비스 선택 조건
      let serviceKeys = []

      if (this.type === 'jamList') {
        if (isETC && (isJourney || isHeatmap)) {
          serviceKeys = Object.keys(jamList)
        } else if (isJourney || isHeatmap) {
          serviceKeys = Object.keys(jamList).filter(key => !ETC_KEYS.includes(key))
        } else if (isETC) {
          serviceKeys = ETC_KEYS
        } else {
          serviceKeys = []
        }
      }

      const serviceValues = serviceKeys.flatMap(key => {
        const config = jamList[key]
        if (!config) return []
        const v = config.value
        return Array.isArray(v) ? v : v ? [v] : []
      })

      // 2. 타입 조건 필터링
      let typeKeys = []

      Object.entries(jamList).forEach(([key, config]) => {
        if (isAll) {
          typeKeys.push(key)
        } else if (isAdd && config.type === 'add') {
          typeKeys.push(key)
        } else if (isSubtract && config.type === 'subtract') {
          typeKeys.push(key)
        }
      })

      const typeValues = typeKeys.flatMap(key => {
        const config = jamList[key]
        if (!config) return []
        const v = config.value
        return Array.isArray(v) ? v : v ? [v] : []
      })

      // 3. detailValues 추출
      const detailValues = this.filterJamDetailList
        .filter(item => item.value)
        .flatMap(item => {
          const v = this.type === 'jamList' ? item.detailValue : item.key
          return Array.isArray(v) ? v : v ? [v] : []
        })

      // 4. jamList 키들에서 value 추출 및 평탄화
      const intersect = (a, b) => a.filter(x => b.includes(x))
      let finalValues = []

      if (detailValues.length) {
        // 상세 존재 → AND 조건
        if (serviceValues.length) {
          finalValues = intersect(serviceValues, detailValues)
        } else if (typeValues.length) {
          finalValues = intersect(typeValues, detailValues)
        } else {
          // 서비스도 타입도 없을 때 → 상세만 반환
          finalValues = detailValues
        }
      } else {
        // 상세 없음 → OR + AND 조합
        if (serviceValues.length && typeValues.length) {
          // 서비스와 타입 둘 다 있으면 교집합
          finalValues = intersect(serviceValues, typeValues)
        } else if (serviceValues.length) {
          finalValues = serviceValues
        } else if (typeValues.length) {
          finalValues = typeValues
        }
      }

      return [...new Set(finalValues)]
    },
    onClose () {
      this.$emit('onClose')
    },
    onCheckFilterPaymentDetail (key) {
      if (key === 'all') {
        const allItem = this.filterPaymentDetailList.find(detail => detail.key === 'all')
        const nextValue = !(allItem && allItem.value)

        this.filterPaymentDetailList.forEach(detail => {
          detail.value = nextValue
        })
      }

      let allCheckCount = 0
      const listCount = this.filterPaymentDetailList.length - 1

      this.filterPaymentDetailList.forEach(detail => {
        if (detail.key === key) {
          detail.value = !detail.value
        }

        if (detail.key !== 'all' && detail.value) {
          allCheckCount++
        }
      })

      const allItem = this.filterPaymentDetailList.find(detail => detail.key === 'all')
      if (allItem) {
        allItem.value = allCheckCount === listCount
      }

      this.onCheckChangeFilter()
    },
    onCheckFilterJam (key, value) {
      const keyName = 'filterJam' + key

      if (value === undefined) {
        this[keyName].value = !this[keyName].value
      } else {
        this[keyName].value = value
      }

      if (key === 'All') {
        this.filterJamAdd.value = this[keyName].value
        this.filterJamSubtract.value = this[keyName].value
      } else {
        this.filterJamAll.value = this.filterJamAdd.value && this.filterJamSubtract.value
      }

      this.onCheckChangeFilter()
    },
    onCheckFilterService (key, value) {
      const keyName = 'filterService' + key

      if (value === undefined) {
        this[keyName].value = !this[keyName].value
      } else {
        this[keyName].value = value
      }

      if (key === 'All') {
        this.filterServiceJourney.value = this[keyName].value
        this.filterServiceHeatmap.value = this[keyName].value
        this.filterServiceETC.value = this[keyName].value
      } else {
        this.filterServiceAll.value =
          this.filterServiceJourney.value &&
          this.filterServiceHeatmap.value &&
          this.filterServiceETC.value
      }

      if (this.filterJamAdd.value !== this.filterJamSubtract.value) {
        this.filterJamDetailList[0].value = false
      }

      this.onCheckChangeFilter()
    },
    onCheckFilterJamDetail (key) {
      if (key === 'all') {
        const allItem = this.filterJamDetailList.find(detail => detail.key === 'all')
        const nextValue = !(allItem && allItem.value)

        this.filterJamDetailList.forEach(detail => {
          detail.value = nextValue
        })
      }
      let allCheckCount = 0
      const listCount = this.filterJamDetailList.length - 1

      this.filterJamDetailList.forEach(detail => {
        if (detail.key === key) {
          detail.value = !detail.value
        }

        if (detail.key !== 'all' && detail.value) {
          allCheckCount++
        }
      })
      const allItem = this.filterJamDetailList.find(detail => detail.key === 'all')
      if (allItem) {
        allItem.value = allCheckCount === listCount
      }
      this.onCheckChangeFilter()
    },
    onCalendarDateChange (dateType, value) {
      if (dateType === 'endDate' && value === null) {
        this.endDate = value
        return
      } else if (dateType === 'startDate' && value === null) {
        this.startDate = value
        return
      }

      this.startDateStr = dateType === 'startDate' ? value : this.startDateStr
      this.endDateStr = dateType === 'endDate' ? value : this.endDateStr

      let dateValue = parse(value)

      if (dateType === 'startDate') {
        dateValue = startOfDay(dateValue)
      } else {
        dateValue = endOfDay(dateValue)
      }

      let serverDateStr = format(dateValue, 'YYYY-MM-DD')

      if (dateType === 'startDate') {
        this.startDate = serverDateStr
      } else {
        this.endDate = serverDateStr
      }
      this.onCheckChangeFilter()
    },
    toggleDatePicker (type) {
      switch (type) {
        case 'start':
          this.showStartDatePicker = !this.showStartDatePicker
          this.showEndDatePicker = false
          break
        case 'end':
          this.showEndDatePicker = !this.showEndDatePicker
          this.showStartDatePicker = false
          break
      }
    },
    initDate () {
      this.startDate = null
      this.endDate = null
      this.startDateStr = null
      this.endDateStr = null
      this.isChangeFilter = true
      this.$emit('onChangeDate', null, null)
    },
    setFilterData () {
      this.filterJamDetailList = JSON.parse(JSON.stringify(this.filterList))
      this.filterPaymentDetailList = JSON.parse(JSON.stringify(this.filterPaymentList))
      this.startDate = JSON.parse(JSON.stringify(this.dateRange.startDate))
      this.endDate = JSON.parse(JSON.stringify(this.dateRange.endDate))
      this.startDateStr = this.startDate
      this.endDateStr = this.endDate

      if (this.jamValue) {
        this.filterJamAdd.value = !!this.jamValue.add
        this.filterJamSubtract.value = !!this.jamValue.subtract

        this.filterJamAll.value = this.filterJamAdd.value && this.filterJamSubtract.value
      }

      const serviceFilters = [
        this.filterServiceJourney,
        this.filterServiceHeatmap,
        this.filterServiceETC
      ]
      const serviceTypes = this.serviceType || []
      serviceFilters.forEach(filter => {
        filter.value = serviceTypes.includes(filter.key)
      })

      const isServiceAll = serviceFilters.some(filter => filter.value === false)

      this.filterServiceAll.value = !isServiceAll

      this.updateAllCheckbox(this.filterJamDetailList)

      this.updateAllCheckbox(this.filterPaymentDetailList)

      this.onCheckChangeFilter()
    },
    updateAllCheckbox (list) {
      const allItem = list.find(item => item.key === 'all')
      if (!allItem) return

      const checkedCount = list.filter(item => item.key !== 'all' && item.value).length
      const totalCount = list.length - 1

      allItem.value = checkedCount === totalCount
    }
  },
  watch: {
    filterList () {
      this.setFilterData()
    },
    filterPaymentList () {
      this.setFilterData()
    },
    dateRange () {
      this.setFilterData()
    }
  },
  created () {
    this.originServiceState = {
      journey: Array.isArray(this.serviceType) && this.serviceType.includes('ba'),
      heatmap: Array.isArray(this.serviceType) && this.serviceType.includes('beusable'),
      etc: Array.isArray(this.serviceType) && this.serviceType.includes('etc')
    }

    this.originJamState = {
      jamAdd: this.jamValue ? !!this.jamValue.add : this.filterJamAdd.value,
      jamSubtract: this.jamValue ? !!this.jamValue.subtract : this.filterJamSubtract.value
    }

    this.setFilterData()

    this.closeFn = () => {
      this.$emit('onClose')
    }
    document.body.addEventListener('click', this.closeFn, false)
  }
}
</script>

<style lang="scss" scoped>
.jam-filter-wrap {
  position: relative;
  padding: 25px;
  display: inline-block;
  box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);

  & .icon--close-btn {
    position: absolute;
    right: 25px;
    cursor: pointer;
  }

  & .date {
    padding-bottom: 20px;
    border-bottom: 1px dashed #d7d7d7;

    & .desc {
      color: #767676;
      font-size: 13px;
      font-style: normal;
      font-weight: 500;
      line-height: 16px;
      margin-bottom: 10px;
    }

    & .date_picker_input--wrap {
      display: flex;
      align-items: center;

      .date_seperator {
        padding: 0 5px 0 5px;
      }

      .date_picker_input {
        position: relative;
        width: 130px;
        height: 38px;

        input {
          text-indent: 35px;
          display: inline-block;
          width: 160px;
          height: 38px;
          border-radius: 6px;
          border: solid 1px #bbbbbb;
          background-color: #ffffff;
          box-sizing: border-box;
          font-size: 14px;
          color: #999999;
        }
        .icon--calendar-input {
          position: absolute;
          top: 50%;
          left: 10px;
          transform: translateY(-50%);
        }
      }

      & .reset {
        position: relative;
        &:before {
          content:'';
          float:left;
          margin:4px 15px;
          width: 1px;
          height: 14px;
          background-color: #d7d7d7;
        }

        & i {
          cursor: pointer;

          .icon--filter-hover {
            display: none;
            position: absolute;
            top: -9px;
            left: 22px;
          }
          &:hover {
            .icon--filter-hover {
              display: block;
            }
          }
        }
      }
    }
  }

  & .filter {
    position: relative;
    margin-top: 25px;
    height: 100%;
    display: inline-block;
    & .type {
      position: relative;
      float: left;
      width: 150px;
      height: 100%;

      & .title {
        & span {
          color: #767676;
          font-size: 13px;
          font-style: normal;
          font-weight: 500;
          line-height: 16px; /* 123.077% */
        }
      }

      &.type-jam {
        margin-right: 15px;
      }
      &.type-detail {
        margin-right: 20px;
      }

      & .filter-list {
        position: relative;
        height: 100%;
        margin-top: 20px;

        & li {
          margin-bottom: 14px;

          &/deep/ span {
            position: relative;
            color: #2F2F2F;
            font-size: 13px;
            font-style: normal;
            font-weight: 400;
            line-height: 19px; /* 146.154% */
            display: inline-block;

            & .icon {
              top: 0;
              transform: translateY(0%);
            }

            & .text {
              max-width: 130px;
              word-break: keep-all;
            }
          }
        }

        & .ui_checkbox:nth-last-of-type(1) {
          margin-left: 0;
        }
      }
    }

    .filter-chk-list {
      display: flex;
      flex-direction: column;
      float: left;
      gap: 50px;
    }

  }

  & .buttons {
    position: relative;
    margin-top: 11px;
    border-top: 1px solid #D7D7D7;
    padding-top: 25px;
    text-align: center;

    & /deep/ button {
      &:nth-child(1) {
        margin-right: 5px;
      }
    }
  }
}
</style>
